import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    GET_PUSH_MESSAGES: (
        pageSizeCount,
        pageNumber,
        searchValue
    ) => ({
        url: `beheer/log-push-messages?perPage=${pageSizeCount}&page=${pageNumber}&search=${searchValue}`,
        method: "get",
    }),
};

export const usePushMessages = (
    pageSizeCount,
    pageNumber,
    searchValue
) =>
    useApiFetcherSWR(
        API_ENDPOINT.GET_PUSH_MESSAGES(
            pageSizeCount,
            pageNumber,
            searchValue
        )
    );